<ion-button
  fill="outline"
  (click)="showUploadFreightFileModal()"
>
  <ion-icon
    aria-hidden="true"
    slot="start"
    src="../assets/material-symbols/upload_file_24dp.svg"
  ></ion-icon>
  Importar Excel
</ion-button>
